<script setup lang="ts">
import NewsOverview from "../../NewsOverview.vue"

const props = defineProps<{
    element: any
}>()
</script>

<template>
    <NewsOverview :primary-categories="props.element.config.newsCategories" />
</template>
